import { atom } from "recoil"

interface ParticipantsState {
  roomId: string;
  users: string[];
}

const participantsStateDefault: ParticipantsState = {
  roomId: 'square',
  users: [],
}

const participantsState = atom({
  key: 'participants',
  default: participantsStateDefault
});

export default participantsState;